<template>
  <div>
    <b-row>
      <b-col>
        <ResourcesView v-if="!loadingSettings" :show-title="true" :block="widgetEditBlock" class="white-container widgets-block" :prefill-params="widgetsPrefill"/>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <ResourcesView v-if="!loadingSettings" :show-title="true" :block="settingsEditBlock" class="white-container" :prefill-params="settingsPrefill"/>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <loader class="mb-5 mt-5" v-if="loadingSettings"/>
        <div class="white-container">
          <h4 class="mb-4 mt-2">
              {{$t('dashboard.choose_paid_plans')}}
          </h4>
            <DragAndDropField :lists="lists" col columnsMd="4" columnsLg="4" columnsSm="10" columnsXs="10">
              <template slot-scope="{ item }">
                <div v-if="item" class="list-group-item mb-3" :key="item.id">
                    <h4>
                      {{$t('form.plan')}}:
                      <router-link :to="`/plans/edit/${item.plan.id}`">{{ item.plan.title }}</router-link>
                    </h4>
                  <div>
                    <div>
                      <span>
                          {{$t('users.editing.subscription')}}:
                        {{ item.title }} ({{item.period}})
                      </span>
                    </div>
                    <div>
                      <span class="font-italic">
                        {{$t('form.price')}}:
                        {{ item.price }} {{item.currency}}
                      </span>
                    </div>
                  </div>
                </div>
              </template>
            </DragAndDropField>
          </div>
      </b-col>
    </b-row>
    <form-buttons class="mb-5" @submit="updateSettings"></form-buttons>
  </div>
</template>

<script>
import ResourcesView from "@/views/resources/ResourcesView";
import DragAndDropField from "@/components/forms/dragAndDropField";
import {mapGetters} from "vuex";
import {getArraysOfParameter} from "../../utils/object-utils";
import i18n from '@/utils/i18n';

export default {
  name: 'DashboardSettings',
  middleware: 'auth',
  components: {DragAndDropField, ResourcesView},
  data () {
    return {
      currencyOptions: [],
      widgetEditBlock: {
        title: 'Show widgets',
        columns: 4,
        items: [
          {
            label:this.$t('dashboard.total_revenue'),
            name:"total_revenue",
            type:"checkbox"
          },
          {
            label:this.$t('dashboard.subscribers_statistics'),
            name:"subscribers_statistics",
            type:"checkbox"
          },
          {
            label:this.$t('dashboard.members_by_plan'),
            name:"members_by_plan",
            type:"checkbox"
          },
          {
            label: this.$t('dashboard.transactions_by_month'),
            name: "transactions_by_month",
            type:"checkbox"
          },
          {
            label: this.$t('dashboard.member_registrations'),
            name: 'members_signups',
            type: 'checkbox'
          },
          {
            label: this.$t('dashboard.advanced_statistic'),
            name: 'advanced_statistic',
            type: 'checkbox'
          }
        ],
      },
      settingsEditBlock: {
        title: 'Settings',
        columns: 4,
        items: [
          {
            name: 'default_stats_currency',
            type: 'select',
            searchable: false,
            clearable: false,
            label: i18n.t('dashboard.default_currency_settings'),
            options: [],
          },
        ],
      },
      widgetsPrefill: {
        total_revenue: false,
        subscribers_statistics: false,
        members_by_plan: false,
        transactions_by_month: false,
        members_signups: false,
        advanced_statistic: false,
      },
      settingsPrefill: {
        default_stats_currency: {'value': 'usd', 'name': 'USD'},
      },
      lists: {
        'unsubscribed': {
          title: this.$t('dashboard.all_plans'),
          items: []
        },
        'paid': {
          title: this.$t('dashboard.paid_plans'),
          items: []
        },
        'free': {
          title: this.$t('dashboard.free_plans'),
          items: []
        },
      },
      loadingSettings: false
    }
  },

  computed: {
    ...mapGetters('resource', ['currentResource']),
    updateSettingsQueryParams() {
      let settingsData = this.settingsPrefill;
      settingsData.default_stats_currency = settingsData.default_stats_currency.value;
      return {
        settings: {
          display_panels: this.widgetsPrefill,
          default_configs: settingsData,
          subscriber_types: {
            'free': {
              subscription_ids: getArraysOfParameter(this.lists.free.items, 'id'),
            },
            'paid': {
              subscription_ids: getArraysOfParameter(this.lists.paid.items, 'id')
            }
          }
        }
      }
    },
  },

  watch: {
    currentResource: {
      handler () {
        this.getSettings()
      },
      deep: true
    }
  },

  async mounted() {
    await this.getResourceAvailableCurrencies();
    this.getSettings();
    let currencyFieldIndex = this.settingsEditBlock.items.findIndex((item) => item.name === 'default_stats_currency');
    this.settingsEditBlock.items[currencyFieldIndex].options = this.currencyOptions;
  },

  methods: {
      async getResourceAvailableCurrencies() {
        await this.getData(`dashboard/statistics/currencies`)
                .then(response => {
                  if(response.data.items && response.data.items.length) {
                    this.currencyOptions = response.data.items.map((option) => {
                      return {
                        value: option.toLowerCase(),
                        name: option.toUpperCase()
                      };
                    });
                  }
                })
                .catch(error => {
                  console.log('get currencies error', error)
                })
                .finally(() => {
                })
      },
      async getSettings() {
        this.loadingSettings = true
        this.getData(`resources/dashboard/settings`)
            .then(response => {
              for (const listName in response.data.subscriber_types) {
                if (response.data.subscriber_types && response.data.subscriber_types[listName] && response.data.subscriber_types[listName].subscriptions) {
                  this.lists[listName].items = response.data.subscriber_types[listName].subscriptions
                  this.lists[listName].items.forEach((subscription) => {
                    if (typeof subscription.price === 'number') {
                      subscription.price = this.formatAmount(subscription.price)
                    }
                  })
                } else {
                  this.lists[listName].items = []
                }
              }
              this.widgetsPrefill = {...this.widgetsPrefill, ...response.data.display_panels};
              if(_.has(response.data.default_configs, 'default_stats_currency')) {
                this.settingsPrefill.default_stats_currency = {
                  value: response.data.default_configs.default_stats_currency.toLowerCase(),
                  name: response.data.default_configs.default_stats_currency.toUpperCase(),
                };
              }
              else {
                this.settingsPrefill.default_stats_currency = _.first(this.currencyOptions);
              }
            })
            .catch(error => {
              console.log('get settings error', error)
            })
            .finally(() => {
              this.loadingSettings = false
            })
      },
      async updateSettings() {
        this.loadingSettings = true;
          this.putData(`resources/dashboard/settings`, {
            ...this.updateSettingsQueryParams
          })
          .then(response => {
            for (const listName in response.data.subscriber_types) {
             this.lists[listName].items = response.data.subscriber_types[listName].subscriptions
            }
            this.widgetsPrefill = {...this.widgetsPrefill, ...response.data.display_panels};

            if(_.has(response.data.default_configs, 'default_stats_currency')) {
              this.settingsPrefill.default_stats_currency = {
                value: response.data.default_configs.default_stats_currency.toLowerCase(),
                name: response.data.default_configs.default_stats_currency.toUpperCase(),
              };
            }
          })
          .catch(error => {
            this.$t(error)
          })
          .finally(() => {
            this.loadingSettings = false
            this.$router.push('/dashboard')
          })
      },
  }
}
</script>
